// app/javascript/controllers/track_changes_controller.js
import { Controller } from "@hotwired/stimulus"
export default class extends Controller {
    static targets = [
        "nameField",
        "unitPrice",
        "installMaterial",
        "installLabor",
        "pricingCategory",
        "quantityField",
        "laborRate",
        "markupRate"
    ];

    connect() {
        this.changedIds = [];
    }

    trackChange(event) {
        const inputElement = event.currentTarget;
        if (!this.changedIds.includes(inputElement.name)) {
            this.changedIds.push(inputElement.name);
            inputElement.dataset.changed = "true";
        }
    }

    afterSubmit() {
        this.allTrackedTargets().forEach((input) => {
            input.disabled = false;
            delete input.dataset.changed;
        });
        this.changedIds = [];
    }

    allTrackedTargets() {
        return [
            ...this.nameFieldTargets,
            ...this.unitPriceTargets,
            ...this.installMaterialTargets,
            ...this.installLaborTargets,
            ...this.pricingCategoryTargets,
            ...this.quantityFieldTargets,
            ...this.laborRateTargets,
            ...this.markupRateTargets
        ];
    }
}
